import React, { Component, Fragment, useEffect, useCallback, useState, useRef } from 'react';
import "./style.css";
import {
  Breadcrumb,
  Button,
  Space,
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  Upload,
  Spin,
  Radio,
  Select,
  DatePicker,
} from "antd";
import {
  CameraOutlined,
  LoadingOutlined,
  UserOutlined,
  SyncOutlined
} from "@ant-design/icons";
import Container from "../../Layout/Container";
import { Link, useHistory, useLocation, Redirect } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import ability from '../../../config/ability';
import MaskedInput from 'antd-mask-input'
import { getTemplatesAsyn, getReferenceNoAsyn, getUsersNameAsyn, clearAllUsersNameState, AddDocumentAsyn, clearAddResponseState, adddocumentSelector, clearState, responseState, clearResponseState } from './AddDocumentSlice';
import moment from 'moment';
import {authSelector} from '../../Auth/authSlice';
import {myRef} from '../../newRef'
//import { objectFromMap } from 'pdfjs-dist/types/shared/util';
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

let mxxx="";



export default function AddDocument() {
  const { Option } = Select;
  const location = useLocation();
  const [isToast, setToast] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [pending, setPending] = useState(false)
  const dispatch = useDispatch();
  let history = useHistory();
  const [subjectVal, setSubjectVal] = useState('')
  const [state, setState] = useState({})
  const [form] = Form.useForm()
  const [UserList, setUserList] = useState([]);
 
  const [slecetedUserList, setslecetedUserList] = useState([
    
  ]);
  const [sendUserData, setsendUserData] = useState([]);

  const { isFetching, isSuccess, isError, errorMessage, response, isResponse, seenStampData, allUserNames, isUsersNameSuccess, templates, referenceNos, isAddResponse } = useSelector(
    adddocumentSelector
  );

  if(location.state==undefined){
    //  alert("Kindly re-upload your file")
      history.push("/dashboard");
      window.location.reload()
    
      // dispatch(logout()).then((res) => {
      //   setLoading(false);
      //   history.push("/login");
      //   window.location.reload()
      // });
    
     }
 
  useEffect(() => {
    dispatch(clearState());
    setLoading(true);
    // dispatch(getTemplatesAsyn());
    dispatch(getReferenceNoAsyn());
    dispatch(getUsersNameAsyn());
  }, []);


  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage.toUpperCase());

    }
    if (isSuccess) {
      setLoading(false);
    }

    if (isResponse) {
      setLoading(false);
      dispatch(clearResponseState());
    }

    if (isAddResponse) {
      setLoading(false);
      dispatch(clearAddResponseState());
      history.push({
        pathname: '/verify-document',
        // search: '?query=abc',
        state: { documentInfo: response, processId: response.documentUpdatedData.processId }
        //state: { documentInfo:response }
      });

    }


    if (isUsersNameSuccess) {
      // let dref = [];
      // setTimeout(async () => {
      //   let getAllData = await allUserNames.forEach(val => {
      //     dref.push({ tittle: val.fullName, dataIndex: val })
      //   });

      setUserList(allUserNames);
      setmyappt(allUserNames);
      

      //   setLoading(false);
      // }, 4000);

      dispatch(clearAllUsersNameState())

    }


  }, [isError, isSuccess, isResponse, allUserNames, isUsersNameSuccess, isAddResponse, setLoading, setToast]);


  const { user } = useSelector(
    authSelector
  );
  
  const loggedInUser = user.username ;
 // console.log(loggedInUser,"loggedinuser")

  const onClickListChange = (x,e) => {

    console.log(e.props, "mytesting");

    let dummyArray = []
    for (var i = 0; i < e.length; i++) {
      setslecetedUserList(e[i].props.username);
      let data = {
        "username": e[i].props.username,
        "department": 'Chief of Air Staff',
        "departmentType": e[i].props.branch == true ? 'Branch'
          : e[i].props.independentOffice == true ? 'Independent Office'
            : e[i].props.independentDirectorate == true ? 'Independent Directorate'
              : null,
        "departmentTypeName": e[i].props.branch == true ? e[i].props.b_name
          : e[i].props.independentOffice == true ? e[i].props.io_name
            : e[i].props.independentDirectorate == true ? e[i].props.id_name
              : null,
        "directorateWithinBranch": e[i].props.bd_name ?e[i].props.bd_name : '',
        "firstName": e[i].props.fullName,
      }
      dummyArray.push(data)
    
    
     
      
   }
    // console.log("dummyArray=> ", dummyArray);
    setsendUserData([]);
   // setusertemplateArray(dummyArray)
   setsendUserData(dummyArray);
   
    
   // console.log(dummyArray)
  };


  const newReferenceNos = () => {

    let refChild=[]
    myRef.forEach(el =>{
      let mx =el.substring(0,7) ;
      refChild.push(<Option key={el} value={mx} props={el}>{el}</Option>);
  
  
    });
    
   
  
    return refChild;
  }

  const getReferenceNos = () => {
    let children = [];
    let referenceNolist = referenceNos ? referenceNos : [];
    // console.log('referenceNolist')
    // console.log(referenceNolist)
    if (referenceNolist && referenceNolist.length > 0) {
      for (let i = 0; i < referenceNolist.length; i++) {
        children.push(<Option key={i.toString() + i} value={referenceNolist[i].ref}>{referenceNolist[i].ref}</Option>);
      }
    }
    return children;
  }

  console.log(UserList,"userlist");
  let tu = loggedInUser.substring(2);
  UserList.forEach(em =>{
    
    console.log(tu,"AMENDUSERS");
    if (em.username.includes(tu)){
      console.log(em.b_name,"DEPARTMENT");
      
      mxxx = em.b_name;
      if (mxxx.includes("Communications")){
        mxxx = "CIS";
      }
      else if(mxxx.includes("Standard")){
        mxxx = "COSE";
      }
      else if (mxxx.includes("Budget")){
        mxxx = "CAB";
      }
      else if(mxxx.includes("Intelligence")){
        mxxx = "CAI";
      }
      else if (mxxx.includes("Policy")){
        mxxx = "COPP";
      }
      else if (mxxx.includes("Secretary")){
        mxxx = "AIRSEC";
      }
      else if (mxxx.includes("Logistic")){
        mxxx = "LOG";
      }
      else if (mxxx.includes("Training")){
        mxxx = "CTOP";
      }
      else if (mxxx.includes("Medical")){
        mxxx = "CMS";
      }
      //break;
      console.log(mxxx, "MXXX");
      
    }
  });

  const getTemplates = () => {
    let children = [];
    let templateslist = templates ? templates : [];

    if (templateslist && templateslist.length > 0) {
      for (let i = 0; i < templateslist.length; i++) {
        children.push(<Option subject={templateslist[i].processSubject} key={i.toString() + i} value={templateslist[i].uuid}>{templateslist[i].processName}</Option>);
      }
    }
    console.log(children,"OMO");
    return children;
  }

  const getUsers = () => {
    let children = [];
    let allUserNameslist = allUserNames ? allUserNames : [];
    // console.log('allUserNameslist')
    // console.log(allUserNameslist)

    if (allUserNameslist && allUserNameslist.length > 0) {
      for (let i = 0; i < allUserNameslist.length; i++) {
        children.push(<Option subject={allUserNameslist[i]} key={i.toString() + i} value={i}>{allUserNameslist[i].fullName}</Option>);
      }
    }

    return children;
  }


  const setUserInfo = (value, e) => {
    // console.log(`selected ${value}`);
    // console.log(`e  `, e);

    let dummyArray = []
    for (var i = 0; i < e.length; i++) {
      let data = {
        "username": e[i].subject.username,
        "department": 'Chief of Air Staff',
        "departmentType": e[i].subject.branch === true ? 'Branch' : e[i].subject.independentOffice === true ? 'Independent Office' : e[i].subject.independentDirectorate === true ? 'Independent Directorate' : null,
        "departmentTypeName": e[i].subject.bd_parentBranch,
        "directorateWithinBranch": e[i].subject.bd_name,
      }
      dummyArray.push(data)
    }

    // console.log("dummyArray =>", dummyArray);
    // let data = JSON.parse(e);
    // console.log(e.subject)

    // console.log(`${JSON.stringify(dummyArray, 4)}`);
  }

  const setSubject = (value, e) => {
    // let data = JSON.parse(e);
    setSubjectVal(e.subject);
    form.setFieldsValue({
      processdescription: e.subject
    });
  }

  const onDocTypeChange = (value) => {
    // eslint-disable-next-line default-case
    switch (value) {
      case 'External Correspondence':
        return;

      case 'Signal Messages':
        return;
    }
  };


  const shadowuserFunc = (theUser, usertocopy)=>{

  
    let shadowUser={
      "username":usertocopy,
      "department": 'Chief of Air Staff',
      "departmentType":theUser.departmentType,
      "departmentTypeName": theUser.departmentTypeName,
      "directorateWithinBranch": theUser.directorateWithinBranch,
      "firstName":usertocopy.toUpperCase(),
  }
  
  return shadowUser
  
  }
    const onFinish = (values) => {
  
      let tempArray=[...sendUserData];
  
      for (var i = 0; i < sendUserData.length; i++) {
            //ccis in template but not his aa, copy aa
         if(sendUserData[i].username=='ccis' && sendUserData[i].username !='aaccis'){const shadowUser = shadowuserFunc(sendUserData[i],'aaccis')
     tempArray = [...tempArray, shadowUser]; setsendUserData([...tempArray, shadowUser]);
      
   }
               //cose in template but  not his aa, copy aa
        if(sendUserData[i].username=='cose' && sendUserData[i].username !='aacose' ){const shadowUser = shadowuserFunc(sendUserData[i],'aacose'); tempArray = [...tempArray,shadowUser]
       setsendUserData([...tempArray,shadowUser]);
      }
  
  //cose in template but not his aa, copy aa
                if(sendUserData[i].username=='cai' && sendUserData[i].username !='aacai' ){ const shadowUser = shadowuserFunc(sendUserData[i],'aacai');
          tempArray = [...tempArray,shadowUser]; setsendUserData([...tempArray,shadowUser]);
              }
  //cas in template but not his aa, copy aa
        if(sendUserData[i].username=='cas' && sendUserData[i].username !='aacas' ){const shadowUser = shadowuserFunc(sendUserData[i],'aacas');
     tempArray = [...tempArray,shadowUser]; setsendUserData([...tempArray,shadowUser]);
      }
  
      }
  
        
      localStorage.setItem("DOCREF", values.referenceNumber+"/"+ mxxx);
      
      let document = {
        "documentId": location.state.documentId,
        "securityClassification": values.securityClassification,
        "documentType": values.documentType,
        "referenceNumber": values.referenceNumber + "/" + mxxx,
        "restrictDownload": values.restrictDownload == 'yes' ? true : false,
        "receivedFrom": values.receivedFrom ? values.receivedFrom : null,
        "controlNumber": values.controlNumber ? values.controlNumber : null,
        // "template_uuid": values.template_uuid,
        "casstickernote":values.casstickernote,
        "subject": values.subject,
        "signalDate": values.signalDate ? moment(values.signalDate).format() : null,
        "externalReferenceNumber": values.externalReferenceNumber ? values.externalReferenceNumber : null,
        // "seenStamp": values.seenStamp == "Yes" ? true : false,
        "cos_seenStamp": null,
        "automaticTemplate": true,
        "users": tempArray,
      };
      // console.log(document)
      setLoading(true);
      dispatch(AddDocumentAsyn(document));

      console.log(tempArray,"tempArray")
      console.log(document,"docid")
  
    };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };


  const onDateIncomingChange = (value, dateString) => {
    // console.log('Selected Time: ', moment(value).format());
    // console.log('Formatted Selected Time: ', moment(dateString).format());
  }

  




  const theappt =     UserList.map(column => {
    let apptValue = column.appt ? " (" + column.appt + ")" : "";
    return (

      { label: column.fullName + apptValue, value: column }

    )
  
  }

  )
  // console.log(theappt)
  //setslecetedUserList(defaultChecked);
  // console.log(slecetedUserList)


  const getAppt = () => {
    let selchildren = [];
    if (UserList && UserList.length > 0) {
      for (let i = 0; i < UserList.length; i++) {
  
       // if (UserList[i].alreadyChecked === true) {
         // if (UserList[i].username) {
           // dummyArray.push(UserList[i].username)
            selchildren.push(<Option key={UserList[i].username} value={UserList[i].username} props={UserList[i]}>{UserList[i].username.toUpperCase()}</Option>);
  
    
  
  
   
      }
    }
 
      return selchildren;
    }



  //Copy of appt for restore 

  const theapptcopy = theappt;
  //console.log(theapptcopy);
  //Setappointment

    const [myappt, setmyappt] = useState(theapptcopy);
  const [inputValue, setinputValue] = useState();
  let inputEl = useRef();
  

  const getSearchTerm = (e) => {
    console.log(allUserNames, "list myusers");
    let searchItem = e.target.value ;
     setinputValue(e.target.value)
     if (searchItem.length > 0){
const newAppt = UserList.filter((userappt)=>{
 

  return Object.values(userappt)
  .join(" ")
  .toLowerCase()
  .includes(searchItem.toLowerCase());

 
});
  
setUserList(newAppt);
     }else {
      setUserList(myappt);

      }
    // console.log(inputEl.current.options)
     //console.log(UserList)
   
  }
  

  return (
    <>
      <Container>
        <Spin indicator={antIcon} style={{ alignItems: 'center', justifyContent: 'center', justifyItems: 'center', textAlign: 'center', width: '100%', maxHeight: '100%', position: 'fixed', zIndex: 1111, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={isLoading} />
        <Breadcrumb
          style={{ margin: "16px 0", paddingLeft: 50, marginBottom: 0 }}
          separator=">"
        >
          <Breadcrumb.Item><Link to="/dashboard">Dashboard</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Add Document</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-content"
          style={{ marginTop: 0, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }

            <div>
              <Form
                form={form}
                style={{ backgroundColor: "#ffffff" }}
                layout="vertical"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                name="nest-messages"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row
                  style={{
                    paddingTop: 35,
                    paddingBottom: 20,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderTop: "1px solid #dfe0eb",
                    borderBottom: "2px solid #e8e8e8",
                  }}
                >
                  <Col span="5"></Col>
                  <Col span="19">
                    <h1
                      style={{
                        fontWeight: "bold",
                        fontStyle: "normal",
                        fontSize: 24,
                      }}
                    >
                      Add Document
                    </h1>
                  </Col>
                </Row>
                <Row
                  style={{
                    paddingTop: 24,
                    //paddingBottom: 80,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderBottom: "1px solid #dfe0eb",
                    //marginBottom: 10,
                  }}
                >
                  <Col span="5"></Col>
                  <Col span="16">

                    <Row style={{ marginTop: 15 }} className="document-upload-form">
                      <Col span={10} className="margin-right-30">
                        <Form.Item
                          className="form-pdf-icon"
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Process ID
                            </p>
                          }

                        >
                          <img src="./images/pdficon.png" style={{ width: "45px" }} />

                          {location.state.processId}

                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        <Form.Item
                          className="form-addedon"
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 15,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Added On
                            </p>
                          }
                        >
                          {moment(location.state.createdAt).format("D MMM YYYY")}
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row className="document-upload-form">
                      <Col span={10} className="margin-right-30" >
                        <Form.Item
                          name="securityClassification"
                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Security Classification</p>}
                          rules={[{ required: true, message: 'Please select Security Classification' }]}
                          requiredMark={'optional'}
                        >
                          <Select>
                            <Option value="Restricted">Restricted</Option>
                            <Option value="Confidential">Confidential</Option>
                            <Option value="Secret">Secret</Option>
                            <Option value="Top-Secret">Top-Secret</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        {/* <Form.Item
                          name="documentType"
                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Document Type</p>}
                          onChange={onDocTypeChange}
                          rules={[{ required: true, message: 'Please select Document Type' }]}
                          requiredMark={'optional'}
                        >
                          <Select>
                            <Option value="Commanded Letters">Commanded Letters</Option>
                            <Option value="Directed Letters">Directed Letters</Option>
                            <Option value="Demi-official Letters">Demi-official Letters</Option>
                            <Option value="External Correspondence">External Correspondence</Option>
                            <Option value="Electronic Short Message">Electronic Short Message</Option>
                            <Option value="Electronic Mail">Electronic Mail</Option>
                            <Option value="Formal Letters">Formal Letters</Option>
                            <Option value="Loose Minutes">Loose Minutes</Option>
                            <Option value="Memorandum">Memorandum</Option>
                            <Option value="Minutes of a Meeting">Minutes of a Meeting</Option>
                            <Option value="Routine Letters">Routine Letters</Option>
                            <Option value="Signal Messages">Signal Messages</Option>
                          </Select>
                        </Form.Item> */}
                      </Col>
                    </Row>

                    <Row className="document-upload-form">
                      {/* <Col span={22}  style={{paddingRight:40}} > */}
                      <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) => prevValues.documentType !== currentValues.documentType}
                      >
                        {({ getFieldValue }) =>
                          getFieldValue('documentType') === 'External Correspondence' ? (
                            <>
                              <Col span={10} className="margin-right-30" >
                                <Form.Item
                                  name="externalReferenceNumber"
                                  label="External Refrence No"
                                  rules={[{ required: true, message: 'External Refrence No is required' }]}
                                  requiredMark={'optional'}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                              <Col span={10} >
                                <Form.Item
                                  name="receivedFrom"
                                  // rules={[{ required: true, message: 'Please chose restrict download' }]}
                                  // requiredMark={'optional'}
                                  label={<p style={{ marginBottom: '0px' }}>Recived From (External)</p>}  >
                                  <Input className="formInput" placeholder="" />
                                </Form.Item>
                              </Col>
                            </>
                          ) : null
                        }

                      </Form.Item>
                      {/* </Col> */}
                    </Row>

                    <Row className="document-upload-form">

                      <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) => prevValues.documentType !== currentValues.documentType}
                      >

                        {({ getFieldValue }) =>
                          getFieldValue('documentType') === 'Signal Messages' ? (
                            <>
                              <Col span={10} className="margin-right-30" >
                                <Form.Item
                                  name="controlNumber"
                                  label="Control Number"
                                  rules={[{ required: true, message: 'Control number is required' }]}
                                  requiredMark={'optional'}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                              <Col span={10}   >
                                <Form.Item
                                  name="signalDate"
                                  label="Signal Date"
                                  rules={[{ required: true, message: 'Please select signal date' }]}
                                  requiredMark={'optional'}
                                >
                                  {/* <Input /> */}
                                  <DatePicker className={'dtpicker'} onChange={onDateIncomingChange} format={'ll'} style={{ width: '100%', height: 44, backgroundColor: '#fff' }} />
                                </Form.Item>
                              </Col>
                            </>
                          ) : null
                        }
                      </Form.Item>


                    </Row>

                    <Row className="document-upload-form">
                      <Col span={10} className="margin-right-30" >
                        <Form.Item
                          name="referenceNumber"
                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No</p>}
                          rules={[{ required: true, message: 'Please select reference no' }]}
                          requiredMark={'optional'}
                        >
                          <Select  >
                            {/* {getReferenceNos()} */}
                            {newReferenceNos()}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={10}  >
                        <Form.Item
                          className="restricted-download-col"
                          name="restrictDownload"
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: "16px",
                                color: "#6b778c",
                                marginTop: "5px",
                                marginBottom: "0",
                              }}
                            >
                              Restrict Download
                            </p>
                          }
                          // rules={[{ required: true, message: 'Please chose restrict download' }]}
                          // requiredMark={'optional'}
                          initialValue={'Yes'}
                        >
                          <Radio.Group defaultValue="Yes"  >
                            <Radio style={{ paddingRight: "28px" }} value="Yes">Yes</Radio>
                            <Radio style={{ paddingRight: "28px" }} value="No">No</Radio>

                          </Radio.Group>
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* <Row className="document-upload-form">
                      <Col span={22} style={{ paddingRight: 40 }} > */}
                    {/* <Form.Item
                  name="receivedFrom"
                  // rules={[{ required: true, message: 'Please chose restrict download' }]}
                  // requiredMark={'optional'}
                  label={<p style={{ marginBottom: '0px' }}>Recived From (External)</p>}  >
                  <Input className="formInput" placeholder="" />
                </Form.Item> */}
                    {/* </Col>
                  <Col span={10}   > */}
                    {/* <Form.Item
                          name="template_uuid"
                          rules={[{ required: true, message: 'Please select template' }]}
                          requiredMark={'optional'}
                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Template</p>}
                        >
                          <Select
                            onChange={(v, e) => setSubject(v, e)} >
                            {getTemplates()} */}
                    {/* <Option value="Requirement request">Requirement request</Option>
                      <Option value="Memorandum">Requirement Memorandum</Option>
                      <Option value="Loose Minutes">Requirement 1</Option>
                      <Option value="Signal">Requirement Signal</Option> */}
                    {/* </Select>
                        </Form.Item>
                      </Col>
                    </Row> */}

                    {/* <Row className="document-upload-form">
                      <Col span={22} style={{ paddingRight: 40 }} >

                        <Form.Item
                          name="users_uuid"
                          rules={[{ required: true, message: 'Please select users' }]}
                          requiredMark={'optional'}
                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Select Users</p>}
                        >
                          <Select
                            mode="multiple"
                            onChange={(v, e) => setUserInfo(v, e)}
                          >
                            {getUsers()}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row> */}


                    <Row className="document-upload-form">
                      <Col span={22} style={{ paddingRight: 40 }} >
                        {/* Filter Appoinment here.. */}
                  
                     
                        
                      

                        <Form.Item
                          name="users_uuid"
                          // rules={[{ required: true, message: 'Please select users' }]}
                          // requiredMark={'optional'}
                          label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 6, }}>Select APPTS 
                             <div style={{marginBottom:10}}>
                              
                              {/* <Input type="text" 
                        placeholder=' Filter appt' 
                        ref={inputEl}
                        onChange={getSearchTerm}
                        value={inputValue}
                        
                        />
                         */}
                        
                        </div>
                          </p>}
                        >

<Select
                              //   style={{"text-transform":"uppercase"}}
                                mode="multiple"
                                allowClear
                                style={{
                                  width: '100%',
                                }}
                               // className="custom-select-multiple-template ant-select-customize-input"
                                // defaultValue={BranchData ? BranchData : []}
                               // onChange={(event, chnagedata) => onOrgListChange(event, chnagedata)}
                                //onClick={event => { event.preventDefault() }}
                                //options={theappt}
                                  onChange={onClickListChange}
                                  defaultOpen={1}
                                  placeholder="Search by appointment"
                              
                              >
                                 {/* <Option value="None">None</Option> */}
                                {getAppt()} 

                              </Select>
                        </Form.Item>
                      </Col>
                    </Row>


                    {/* <Row className="document-upload-form">
                      <Col span={22} style={{ paddingRight: 40 }} >
                        <Form.Item
                          className="subject-col"
                          name="processdescription"
                          label={<p style={{ marginBottom: '0px' }}>Process Description</p>}  >
                          <TextArea rows="2" style={{ backgroundColor: "#fff" }} readOnly className="formInput" placeholder="Process Description" value={subjectVal} />
                        </Form.Item>
                      </Col>
                    </Row> */}

                    <Row className="document-upload-form">
                      <Col span={22} style={{ paddingRight: 40 }} >
                        <Form.Item
                          className="subject-col"
                          name="subject"
                          rules={[{ required: true, message: 'Please enter subject' }]}
                          requiredMark={'optional'}
                          label={<p style={{ marginBottom: '0px' }}>Subject</p>}  >
                          <TextArea rows="2" style={{ backgroundColor: "#fff" }} className="formInput" placeholder="Subject" value={subjectVal} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row className="document-upload-form">
                      <Col span={22} style={{ paddingRight: 40 }} >
                        <Form.Item
                          className="subject-col"
                          name="casstickernote"
                          // rules={[{ required: true, message: 'Please enter subject' }]}
                          // requiredMark={'optional'}
                          label={<p style={{ marginBottom: '0px' }}>Sticker Note to CAS</p>}  >
                          <TextArea rows="2" style={{ backgroundColor: "#fff" }} className="formInput" placeholder="Subject" value={subjectVal} />
                        </Form.Item>
                      </Col>
                    </Row>


                    {ability.can('clerkPermission', 'seenStamps') &&

                      <Row className="document-upload-form">
                        <Col span={22} style={{ paddingRight: 40 }} >
                          <Form.Item
                            label={
                              <p
                                style={{
                                  fontStyle: "normal",
                                  fontWeight: "normal",
                                  fontSize: "16px",
                                  color: "#6b778c",
                                  // marginTop: "32px",
                                  marginBottom: "0",
                                }}
                              >
                                Do you want to have seen stamp for this process?
                              </p>
                            }
                          >
                            <Form.Item
                              name="seenStamp"
                              initialValue={'Yes'}
                            >
                              <Radio.Group defaultValue="Yes"  >
                                <Radio style={{ paddingRight: "28px" }} value="Yes">Yes</Radio>
                                <Radio style={{ paddingRight: "28px" }} value="No">No</Radio>

                              </Radio.Group>
                            </Form.Item>
                          </Form.Item>
                        </Col>
                      </Row>}

                  </Col>
                  <Col span="3"></Col>
                </Row>


                <Row
                  style={{
                    paddingTop: 24,
                    paddingBottom: 24,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderBottom: "1px solid #dfe0eb",
                    marginBottom: 10,
                  }}
                >
                  <Col span="5"></Col>
                  <Col span="15" style={{ textAlign: "right" }}>

                    <Link to="/dashboard">
                      <Button type="primary" size="large" style={{ marginRight: "10px" }} ghost>
                        Cancel
                      </Button>
                    </Link>
                    <Button htmlType="submit" style={{ marginRight: "10px" }} type="primary" size="large">
                      Next
                    </Button>

                  </Col>
                  <Col span="4"></Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
